import {DataStatus} from 'platform/components';

import {isEmpty} from 'ramda';

import {useReadCodelistQuery} from '@dms/api/core';

import {RentalVehicle} from '../../core/types/RentalVehicle';
import {Field} from './primitives/Field';

export function RentalEquipmentCheckboxes() {
  const {
    data: equipmentData,
    isLoading: isLoadingEquipment,
    isError: isEquipmentError,
  } = useReadCodelistQuery({codelistId: 'equipment'});

  const equipmentOptions =
    equipmentData?.codes?.map((code) => ({
      value: code.codeId,
      label: code.name,
    })) || [];

  return (
    <DataStatus
      isEmpty={isEmpty(equipmentData?.codes)}
      isLoading={isLoadingEquipment}
      isError={isEquipmentError}
      spacing={20}
    >
      <Field<RentalVehicle, 'checkboxes'>
        type="checkboxes"
        name="rentalProperties.equipment"
        options={equipmentOptions}
        direction="vertical"
      />
    </DataStatus>
  );
}
